import SidePanel from 'components/side-panel/SidePanel';
import React, { useEffect, useState } from 'react';
import EditStatusDetailPanel from './EditStatusDetailPanel';
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { UpdateStatusPanelRouteState } from 'routes/types';
import { JobStatus } from '../constant';
import { useLazyGetJobByIdQuery } from '../api';
import { LoadingSpinnerAnimation } from 'assets/animations';
import { If } from 'components';
import Lottie from 'lottie-react';

const UpdateStatusPanel = () => {
  const { rootJobId } = useParams();
  const currentTeam = useAppSelector(selectCurrentTeam);
  const { handleSidePanelClose, refetchJobsList, updateCurrentJobInvoice } = useOutletContext<any>();
  const location = useLocation();
  const [updatedStatus, setUpdatedStatus] = useState<JobStatus>();

  const [getJobByIdQuery, jobByIdState] = useLazyGetJobByIdQuery();
  const { data: jobData, isFetching: isJobByIdFetcing } = jobByIdState;

  const handleStatusSave = () => {
    if (updatedStatus === JobStatus.DONE && jobData.data.invoices?.length > 0) {
      updateCurrentJobInvoice(jobData.data.invoices[0], jobData.data.id);
    }
    refetchJobsList();
    handleSidePanelClose();
  };

  useEffect(() => {
    const routeState = location.state as UpdateStatusPanelRouteState;
    if (routeState?.updatedStatus) {
      setUpdatedStatus(routeState?.updatedStatus);
      if (routeState.updatedStatus === JobStatus.DONE) {
        getJobByIdQuery({ jobId: rootJobId, teamId: currentTeam.id });
      }
    }
  }, [location]);

  return (
    <SidePanel isOpen={true} onClose={handleSidePanelClose} shouldAnimate={true}>
      <If condition={isJobByIdFetcing}>
        <div className="flex h-full w-96 items-center justify-center">
          <Lottie className="h-28 w-28" animationData={LoadingSpinnerAnimation} loop={true} />
        </div>
      </If>
      <If condition={!isJobByIdFetcing}>
        <EditStatusDetailPanel
          status={updatedStatus}
          isRootState={true}
          onBackClick={handleSidePanelClose}
          onSave={handleStatusSave}
          jobId={rootJobId}
          teamId={currentTeam.id}
        />
      </If>
    </SidePanel>
  );
};

export default UpdateStatusPanel;
